// This file is generated by a script and should not be modified directly.
const markdown: string =
  "- `null` si et seulement si aucune fiche RNCP correspondant au diplôme (`identifiant.cfd`) n'est connu.\n- Lorsque le code est `null`, toutes les informations issues de France Compétence seront `null`\n"
export default markdown
